<template>
    <LayoutSoundConsoleGrid>
        <template v-slot:elliot>
            <BaseElliotHead />
        </template>
        <template v-slot:text>
            <BaseTextCloud>
                {{ activeSlide.text}}
                <template v-slot:button>
                    <button class="instructions-next" @click="next">
                        {{ isLastSlide ? 'Start' : 'Next' }}
                        <font-awesome-icon :icon="['fas', 'chevron-circle-right']" />
                    </button>
                </template>
            </BaseTextCloud>
        </template>
        <template v-slot:bottom>
            <div class="inst-image">
                <img :src="`/img/instructions/${activeSlide.image}`" >
            </div><!-- .inst-image -->
        </template>
    </LayoutSoundConsoleGrid>
</template>

<style lang="scss" scoped>
    
    @import '../scss/design.scss';

    .instructions-next {
        font-size: 24px;
        background-color: white;
        padding: .25em .35em;
        border-radius: 999px;
        color: $color-link;
        &:hover,
        &:focus {
            color: $color-link-over;
        }
    }

    .inst-image {
        max-width: 640px;
        margin: 0 auto;
        background-color: #333;
        position: relative;
        border-radius: 16px;
        overflow: hidden;
        border: 12px $color-blue solid;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        &:after {
            content: '';
            display: block;
            padding-bottom: percentage(200/640);
        }
    }
</style>

<script>
import LayoutSoundConsoleGrid from './LayoutSoundConsoleGrid';
import BaseTextCloud from './BaseTextCloud';
import BaseElliotHead from './BaseElliotHead';

export default {
    components: {
        BaseTextCloud,
        BaseElliotHead,
        LayoutSoundConsoleGrid
    },
    data() {
        return {
            currentIndex: 0,
            slides: [
                {
                    text: `Welcome to the Elliot's Park sound console!`,
                    image: '00_image.jpg',
                },
                {
                    text: `Here’s how the sound console works.`,
                    image: '01_image.jpg',
                },
                {
                    text: `To play the next sound, press the BIG orange button.`,
                    image: '02_image.jpg',
                },
                {
                    text: `If you want to add some extra sounds, press any of the four small buttons.`,
                    image: '03_image.jpg',
                },
                {
                    text: `You’re ready to begin, press “Start” and load up the sound console.`,
                    image: '04_image.jpg',
                },
            ]
        }
    },
    methods: {
        next() {
            if(this.isLastSlide) {
                this.$emit('start');
                return;
            }
            this.currentIndex++;
        }
    },
    computed: {
        activeSlide() {
            return this.slides[this.currentIndex];
        },
        isLastSlide() {
            return this.currentIndex === this.slides.length - 1;
        }
    }
}
</script>